// VN PWA
// service worker registration

import { MESSAGE_PRECACHE } from './service-worker'
import { clearCaches, sendMessage } from './VNCache/Utils'

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/),
)

export function register(config) {
  if ('serviceWorker' in navigator === false) {
    throw new Error('Unsupported browser')
  }

  // The URL constructor is available in all browsers that support SW.
  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href)
  if (publicUrl.origin !== window.location.origin) {
    return
  }

  const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`

  if (config?.forceRegistration) {
    checkValidServiceWorker(swUrl, config)
    return
  }

  // load service worker
  window.addEventListener('load', () => {
    if (isLocalhost) {
      // This is running on localhost. Let's check if a service worker still exists or not.
      checkValidServiceWorker(swUrl, config)

      // Add some additional logging to localhost, pointing developers to the
      // service worker/PWA documentation.
      navigator.serviceWorker.ready.then(() => {
        console.log('This web app is served by cache-second policy using service workers.')
      })
      return
    }

    // Register service worker directly
    registerValidSW(swUrl, config)
  })
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      // Handle updates and activation
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      }

      registration.onupdatefound = () => {
        const installingWorker = registration.installing
        if (installingWorker == null) {
          return
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // At this point, the updated precached content has been fetched,
              // but the previous service worker will still serve the older
              // content until all client tabs are closed.
              console.log(
                'New content is available and will be used when all ' +
                  'tabs for this page are closed. See https://bit.ly/CRA-PWA.',
              )

              // Execute callback
              if (config && config.onUpdate) {
                config.onUpdate(registration)
              }
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              console.log('Content is cached for offline use.')

              // Execute callback
              if (config && config.onSuccess) {
                config.onSuccess(registration)
              }
            }
          }
        }
      }

      if (config?.primeCache) {
        registration.update().then(async () => {
          await sendMessage(MESSAGE_PRECACHE)

          window.location.reload()
        })
      }
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error)
      throw new Error(error)
    })
}

function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get('content-type')
      if (response.status === 404 || (contentType != null && contentType.indexOf('javascript') === -1)) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration) => {
          if (!registration) return
          registration.unregister().then(() => {
            window.location.reload()
          })
        })
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl, config)
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.')
    })
}

/**
 * Unregisters current service worker
 */
const unregisterServiceWorker = async () => {
  const registration = await navigator.serviceWorker.getRegistration()
  if (!registration) {
    console.error('Error unregistering service worker')
    return
  }
  await registration.unregister()
}

/**
 * Unregisters Service Worker, clear caches and reloads screen to reset cache policies
 */
export async function unregister() {
  if ('serviceWorker' in navigator === false) {
    throw new Error('Unsupported browser')
  }

  try {
    // Clear Service Worker caches
    await clearCaches()

    // Unregister the service worker
    await unregisterServiceWorker()

    setTimeout(() => window.location.reload(true), 450)
  } catch (error) {
    throw new Error(error.message)
  }
}
